import { useEffect } from "react";
import useSessionStorage from "react-use/lib/useSessionStorage";

export function usePersistedParams() {
  const [params, setParams] = useSessionStorage(
    "@neurosity/params",
    {}
  );

  useEffect(() => {
    const newParams = Object.fromEntries(
      new URLSearchParams(window.location.search)
    );

    const hasParams = !!Object.keys(newParams).length;

    if (hasParams) {
      const mergedParams = { ...params, ...newParams };
      setParams(mergedParams);
    }
  }, []);

  return params;
}
